module.exports = __webpack_public_path__ + "static/media/18ECA29.b99c8f8e.jpg";